import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currencies: [],
  loading: false,
  error: null,
};

const currencySlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    fetchCurrenciesRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCurrenciesSuccess(state, action) {
      state.loading = false;
      state.currencies = action.payload;
    },
    fetchCurrenciesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchCurrenciesRequest, fetchCurrenciesSuccess, fetchCurrenciesFailure } = currencySlice.actions;

export const getCurrencyOption = (state, value) => {
  if (value) {
    const found = state.find((currency) => currency.Code === value);
    return found ? found.Code : null;
  }
  return null;
};

export default currencySlice.reducer;
